import { decomposePlaceValue, type CrystalNumberBuilderConfig, type PlaceValueDigits } from './CrystalNumberBuilderConfig.js';

export type PlaceValueKind = keyof PlaceValueDigits;

export class CrystalNumberBuilderState {
  readonly required: PlaceValueDigits;
  readonly counts: PlaceValueDigits = { hundreds: 0, tens: 0, ones: 0 };

  constructor(readonly config: CrystalNumberBuilderConfig) {
    this.required = decomposePlaceValue(config.target);
  }

  add(kind: PlaceValueKind) {
    if (this.counts[kind] >= 9) return false;
    this.counts[kind] += 1;
    return true;
  }

  remove(kind: PlaceValueKind) {
    if (this.counts[kind] <= 0) return false;
    this.counts[kind] -= 1;
    return true;
  }

  get value() {
    return this.counts.hundreds * 100 + this.counts.tens * 10 + this.counts.ones;
  }

  get hasPieces() {
    return this.value > 0;
  }

  get isCorrect() {
    return this.counts.hundreds === this.required.hundreds
      && this.counts.tens === this.required.tens
      && this.counts.ones === this.required.ones;
  }

  get decomposition() {
    return `${this.counts.hundreds * 100} + ${this.counts.tens * 10} + ${this.counts.ones} = ${this.value}`;
  }
}
